<template>
    <div>
        <div class="pl-7 pt-4">
            <div class="font-secundaria headline font-weight-bold fontColor1--text">
                RELATÓRIOS
            </div>
            <div style="line-height: 8px" class="font-secundaria subtitle-2 fontColor1--text" v-if="!$vuetify.breakpoint.xs">
                Home > Relatórios > <span class="font-weight-bold"> {{tabName}} </span>
            </div>
        </div>
        <CardRelatorios @name="value => tabName = value"/>
    </div>
</template>

<script>
import CardRelatorios from './Shared/CardRelatorios'
export default {
  components: {
    CardRelatorios
  },
  data () {
    return {
      tabName: 'Relatórios'
    }
  }
}
</script>

<style>

</style>
